import { Product } from '@@types'

export interface ProductGroup {
  categoryName: string;
  products: Product[];
}

/**
 * Группирует продукты по их верхней (корневой) категории
 * Если у продукта нет категории, он попадает в группу "Без категории"
 */
export function groupProductsByCategory (products: Product[]): ProductGroup[] {
  const groups: Record<string, Product[]> = {}

  products.forEach((product) => {
    const topCategory = product?.categories?.find((category) => !category?.parent_id)
    const categoryName = topCategory?.name ?? 'Без категории'

    if (!groups[categoryName]) {
      groups[categoryName] = []
    }
    groups[categoryName].push(product)
  })

  // Преобразуем в массив и сортируем: "Без категории" в конец
  return Object.entries(groups)
    .map(([ categoryName, categoryProducts ]) => ({
      categoryName,
      products: categoryProducts,
    }))
    .sort((a, b) => {
      if (a.categoryName === 'Без категории') return 1
      if (b.categoryName === 'Без категории') return -1
      return a.categoryName.localeCompare(b.categoryName)
    })
}
